module.exports = __webpack_public_path__ + "img/3.359434d2.jpg";